export const InitMode = {
    ALL: "ALL",
    SEJ: "SEJ",
    KAGOSHIMA: "KAGOSHIMA",
    JOGMEC: "JOGMEC",
    KUMEJIMA: "KUMEJIMA"
} as const;
export type InitMode = typeof InitMode[keyof typeof InitMode];